import React from "react";
import BusinessSidebar from "../components/BusinessSidebar";
import AdminHeader from "./../layout/AdminHeader";
import Footer from "../layout/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import

function BusinessLearningGroups() {
  const { t } = useTranslation("BusinessLearningGroups");

  return (
    <>
      <AdminHeader />
      <section>
        <div className="dashbaord-home-main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-3 col-md-4 col-lg-3 col-xxl-3 d-none d-xl-block px-4 bg-white sidebar-mian">
                <BusinessSidebar />
              </div>
              <div className="col-12 col-md-12 col-lg-12 col-xxl-9 bg-body">
                <div className="row ps-0 ps-lg-4 pe-lg-4 ps-xl-5 dashbaord-right-side justify-content-md-center justify-content-lg-between pt-5">
                  <div className="col-12 col-md-11 col-lg-12 right-side">
                    <div className="row g-4 mb-4">
                      <div className="col-12 col-md-4">
                        <div className="card border-0">
                          <div className="card-body">
                            <img
                              src="admin-images/png/boys-group.png"
                              className="wh-25"
                              alt=""
                            />
                            <div className="d-flex align-items-center gap-2 mt-4">
                              <h2 className="text-black fw-400">2</h2>
                              <span className="text-muted fs-12 fw-400">
                                {t("totallearninggroups")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="card border-0">
                          <div className="card-body">
                            <img
                              src="admin-images/png/interaction.png"
                              className="wh-25"
                              alt=""
                            />
                            <div className="d-flex align-items-center gap-2 mt-4">
                              <h2 className="text-black fw-400">22%</h2>
                              <span className="text-muted fs-12 fw-400">
                                {t("interactionstthisweek")}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="card border-0">
                          <div className="card-body">
                            <img
                              src="admin-images/png/team.png"
                              className="wh-25"
                              alt=""
                            />
                            <div className="d-flex align-items-center gap-2 mt-4">
                              <h2 className="text-black fw-400">3</h2>
                              <span className="text-muted fs-12 fw-400">
                                {t("invitedusers")}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-between align-items-center my-4 my-md-5">
                      <div className="col-12 col-md-6 col-lg-8">
                        <h2 className="fw-600 text-black">
                          {t("learninggroups")}{" "}
                        </h2>
                      </div>
                    </div>
                    <div className="row mb-4 mb-md-5">
                      <div className="col-12 col-md-6">
                        <Link to="/business-group-view">
                          <div className="card border-0">
                            <div className="card-header bg-transparent border-0 pt-4 px-4 px-lg-4 pb-0">
                              <div className="d-flex justify-content-between align-items-start gap-3">
                                <div>
                                  <h4 className="fw-400 text-black">
                                    {t("summerbootcamp")}{" "}
                                  </h4>
                                  <div className="d-flex align-items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={16}
                                      height={16}
                                      viewBox="0 0 16 16"
                                      fill="none"
                                    >
                                      <mask
                                        id="mask0_626_2815"
                                        style={{ maskType: "alpha" }}
                                        maskUnits="userSpaceOnUse"
                                        x={0}
                                        y={0}
                                        width={16}
                                        height={16}
                                      >
                                        <rect
                                          width={16}
                                          height={16}
                                          fill="#D9D9D9"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_626_2815)">
                                        <path
                                          d="M11.332 10.0003C10.8654 10.0003 10.4709 9.83921 10.1487 9.51699C9.82648 9.19477 9.66536 8.80032 9.66536 8.33366C9.66536 7.86699 9.82648 7.47255 10.1487 7.15033C10.4709 6.8281 10.8654 6.66699 11.332 6.66699C11.7987 6.66699 12.1931 6.8281 12.5154 7.15033C12.8376 7.47255 12.9987 7.86699 12.9987 8.33366C12.9987 8.80032 12.8376 9.19477 12.5154 9.51699C12.1931 9.83921 11.7987 10.0003 11.332 10.0003ZM7.9987 13.3337V12.4003C7.9987 12.1337 8.06814 11.8864 8.20703 11.6587C8.34592 11.4309 8.54314 11.267 8.7987 11.167C9.1987 11.0003 9.61259 10.8753 10.0404 10.792C10.4681 10.7087 10.8987 10.667 11.332 10.667C11.7654 10.667 12.1959 10.7087 12.6237 10.792C13.0515 10.8753 13.4654 11.0003 13.8654 11.167C14.1209 11.267 14.3181 11.4309 14.457 11.6587C14.5959 11.8864 14.6654 12.1337 14.6654 12.4003V13.3337H7.9987ZM6.66536 8.00033C5.93203 8.00033 5.30425 7.73921 4.78203 7.21699C4.25981 6.69477 3.9987 6.06699 3.9987 5.33366C3.9987 4.60033 4.25981 3.97255 4.78203 3.45033C5.30425 2.9281 5.93203 2.66699 6.66536 2.66699C7.3987 2.66699 8.02647 2.9281 8.5487 3.45033C9.07092 3.97255 9.33203 4.60033 9.33203 5.33366C9.33203 6.06699 9.07092 6.69477 8.5487 7.21699C8.02647 7.73921 7.3987 8.00033 6.66536 8.00033ZM1.33203 13.3337V11.467C1.33203 11.0892 1.42648 10.742 1.61536 10.4253C1.80425 10.1087 2.06536 9.86699 2.3987 9.70033C3.06536 9.36699 3.75703 9.11144 4.4737 8.93366C5.19036 8.75588 5.92092 8.66699 6.66536 8.66699C7.05425 8.66699 7.44314 8.70033 7.83203 8.76699C8.22092 8.83366 8.60981 8.91144 8.9987 9.00033L7.86536 10.1337C7.66536 10.0781 7.46536 10.042 7.26536 10.0253C7.06536 10.0087 6.86536 10.0003 6.66536 10.0003C6.02092 10.0003 5.39036 10.0781 4.7737 10.2337C4.15703 10.3892 3.56536 10.6114 2.9987 10.9003C2.88759 10.9559 2.80425 11.0337 2.7487 11.1337C2.69314 11.2337 2.66536 11.3448 2.66536 11.467V12.0003H6.66536V13.3337H1.33203ZM6.66536 6.66699C7.03203 6.66699 7.34592 6.53644 7.60703 6.27533C7.86814 6.01421 7.9987 5.70033 7.9987 5.33366C7.9987 4.96699 7.86814 4.6531 7.60703 4.39199C7.34592 4.13088 7.03203 4.00033 6.66536 4.00033C6.2987 4.00033 5.98481 4.13088 5.7237 4.39199C5.46259 4.6531 5.33203 4.96699 5.33203 5.33366C5.33203 5.70033 5.46259 6.01421 5.7237 6.27533C5.98481 6.53644 6.2987 6.66699 6.66536 6.66699Z"
                                          fill="#000C2A"
                                        />
                                      </g>
                                    </svg>
                                    <p className="text-muted fs-7 fw-400 mb-0">
                                      200 {t("members")}{" "}
                                    </p>
                                  </div>
                                </div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_627_3079"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={24}
                                    height={24}
                                  >
                                    <rect
                                      width={24}
                                      height={24}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_627_3079)">
                                    <path
                                      d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                              </div>
                            </div>
                            <div className="card-body p-4 p-lg-4">
                              <div className="learning-groups-images-main ms-3">
                                <img
                                  src="admin-images/png/learning-groups-avatar-1.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-2.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-3.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-4.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-5.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-6.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-7.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-8.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-9.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-10.png"
                                  alt=""
                                />
                                <img
                                  src="admin-images/png/learning-groups-avatar-11.png"
                                  alt=""
                                />
                              </div>
                              <p className="text-muted fs-7 fw-400 mb-0 mt-4">
                                {t("joindes")}
                              </p>
                              <div className="d-flex flex-wrap h-100 gap-3 mt-4">
                                <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                                  {t("marketingandsales")}
                                </span>
                                <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                                  {t("technicalandsecurity")}
                                </span>
                                <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                                  {t("education")}
                                </span>
                              </div>
                              <p className="text-black fs-7 fw-400 mt-4">
                                {t("recentactivity")}{" "}
                              </p>
                              <div className="row justify-content-between align-items-center g-3">
                                <div className="col-7 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_627_3105"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_627_3105)">
                                      <path
                                        d="M3.33203 14.0003V2.66699H9.33203L9.5987 4.00033H13.332V10.667H8.66536L8.3987 9.33366H4.66536V14.0003H3.33203ZM9.76537 9.33366H11.9987V5.33366H8.4987L8.23203 4.00033H4.66536V8.00033H9.4987L9.76537 9.33366Z"
                                        fill="#000C2A"
                                      />
                                    </g>
                                  </svg>
                                  <p className="text-muted fs-7 fw-400 mb-0">
                                    5 {t("newupdates")}
                                  </p>
                                </div>
                                <div className="col-5 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_627_3114"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_627_3114)">
                                      <path
                                        d="M11.9987 14.0003H4.66536V5.33366L9.33203 0.666992L10.1654 1.50033C10.2431 1.5781 10.307 1.68366 10.357 1.81699C10.407 1.95033 10.432 2.0781 10.432 2.20033V2.43366L9.6987 5.33366H13.9987C14.3543 5.33366 14.6654 5.46699 14.932 5.73366C15.1987 6.00033 15.332 6.31144 15.332 6.66699V8.00033C15.332 8.0781 15.3209 8.16144 15.2987 8.25033C15.2765 8.33921 15.2543 8.42255 15.232 8.50033L13.232 13.2003C13.132 13.4225 12.9654 13.6114 12.732 13.767C12.4987 13.9225 12.2543 14.0003 11.9987 14.0003ZM5.9987 12.667H11.9987L13.9987 8.00033V6.66699H7.9987L8.8987 3.00033L5.9987 5.90033V12.667ZM4.66536 5.33366V6.66699H2.66536V12.667H4.66536V14.0003H1.33203V5.33366H4.66536Z"
                                        fill="#000C2A"
                                      />
                                    </g>
                                  </svg>
                                  <p className="text-muted fs-7 fw-400 mb-0">
                                    134 {t("likes")}
                                  </p>
                                </div>
                                <div className="col-7 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_627_3122"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_627_3122)">
                                      <path
                                        d="M1.33203 14.6667V2.66667C1.33203 2.3 1.46259 1.98611 1.7237 1.725C1.98481 1.46389 2.2987 1.33333 2.66536 1.33333H9.3987C9.35425 1.55556 9.33203 1.77778 9.33203 2C9.33203 2.22222 9.35425 2.44444 9.3987 2.66667H2.66536V11.4167L3.43203 10.6667H13.332V5.26667C13.5876 5.21111 13.8265 5.13611 14.0487 5.04167C14.2709 4.94722 14.4765 4.82222 14.6654 4.66667V10.6667C14.6654 11.0333 14.5348 11.3472 14.2737 11.6083C14.0126 11.8694 13.6987 12 13.332 12H3.9987L1.33203 14.6667ZM12.6654 4C12.1098 4 11.6376 3.80556 11.2487 3.41667C10.8598 3.02778 10.6654 2.55556 10.6654 2C10.6654 1.44444 10.8598 0.972222 11.2487 0.583333C11.6376 0.194444 12.1098 0 12.6654 0C13.2209 0 13.6931 0.194444 14.082 0.583333C14.4709 0.972222 14.6654 1.44444 14.6654 2C14.6654 2.55556 14.4709 3.02778 14.082 3.41667C13.6931 3.80556 13.2209 4 12.6654 4Z"
                                        fill="#000C2A"
                                      />
                                    </g>
                                  </svg>
                                  <p className="text-muted fs-7 fw-400 mb-0">
                                    29 {t("comments")}
                                  </p>
                                </div>
                                <div className="col-5 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_627_3130"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_627_3130)">
                                      <path
                                        d="M12 14.6663C11.4444 14.6663 10.9722 14.4719 10.5833 14.083C10.1944 13.6941 10 13.2219 10 12.6663C10 12.5886 10.0056 12.508 10.0167 12.4247C10.0278 12.3413 10.0444 12.2663 10.0667 12.1997L5.36667 9.46634C5.17778 9.63301 4.96667 9.76356 4.73333 9.85801C4.5 9.95245 4.25556 9.99967 4 9.99967C3.44444 9.99967 2.97222 9.80523 2.58333 9.41634C2.19444 9.02745 2 8.55523 2 7.99967C2 7.44412 2.19444 6.9719 2.58333 6.58301C2.97222 6.19412 3.44444 5.99967 4 5.99967C4.25556 5.99967 4.5 6.0469 4.73333 6.14134C4.96667 6.23579 5.17778 6.36634 5.36667 6.53301L10.0667 3.79967C10.0444 3.73301 10.0278 3.65801 10.0167 3.57467C10.0056 3.49134 10 3.41079 10 3.33301C10 2.77745 10.1944 2.30523 10.5833 1.91634C10.9722 1.52745 11.4444 1.33301 12 1.33301C12.5556 1.33301 13.0278 1.52745 13.4167 1.91634C13.8056 2.30523 14 2.77745 14 3.33301C14 3.88856 13.8056 4.36079 13.4167 4.74967C13.0278 5.13856 12.5556 5.33301 12 5.33301C11.7444 5.33301 11.5 5.28579 11.2667 5.19134C11.0333 5.0969 10.8222 4.96634 10.6333 4.79967L5.93333 7.53301C5.95556 7.59967 5.97222 7.67467 5.98333 7.75801C5.99444 7.84134 6 7.9219 6 7.99967C6 8.07745 5.99444 8.15801 5.98333 8.24134C5.97222 8.32467 5.95556 8.39967 5.93333 8.46634L10.6333 11.1997C10.8222 11.033 11.0333 10.9025 11.2667 10.808C11.5 10.7136 11.7444 10.6663 12 10.6663C12.5556 10.6663 13.0278 10.8608 13.4167 11.2497C13.8056 11.6386 14 12.1108 14 12.6663C14 13.2219 13.8056 13.6941 13.4167 14.083C13.0278 14.4719 12.5556 14.6663 12 14.6663ZM12 3.99967C12.1889 3.99967 12.3472 3.93579 12.475 3.80801C12.6028 3.68023 12.6667 3.5219 12.6667 3.33301C12.6667 3.14412 12.6028 2.98579 12.475 2.85801C12.3472 2.73023 12.1889 2.66634 12 2.66634C11.8111 2.66634 11.6528 2.73023 11.525 2.85801C11.3972 2.98579 11.3333 3.14412 11.3333 3.33301C11.3333 3.5219 11.3972 3.68023 11.525 3.80801C11.6528 3.93579 11.8111 3.99967 12 3.99967ZM4 8.66634C4.18889 8.66634 4.34722 8.60245 4.475 8.47467C4.60278 8.3469 4.66667 8.18856 4.66667 7.99967C4.66667 7.81079 4.60278 7.65245 4.475 7.52467C4.34722 7.3969 4.18889 7.33301 4 7.33301C3.81111 7.33301 3.65278 7.3969 3.525 7.52467C3.39722 7.65245 3.33333 7.81079 3.33333 7.99967C3.33333 8.18856 3.39722 8.3469 3.525 8.47467C3.65278 8.60245 3.81111 8.66634 4 8.66634ZM12 13.333C12.1889 13.333 12.3472 13.2691 12.475 13.1413C12.6028 13.0136 12.6667 12.8552 12.6667 12.6663C12.6667 12.4775 12.6028 12.3191 12.475 12.1913C12.3472 12.0636 12.1889 11.9997 12 11.9997C11.8111 11.9997 11.6528 12.0636 11.525 12.1913C11.3972 12.3191 11.3333 12.4775 11.3333 12.6663C11.3333 12.8552 11.3972 13.0136 11.525 13.1413C11.6528 13.2691 11.8111 13.333 12 13.333Z"
                                        fill="#000C2A"
                                      />
                                    </g>
                                  </svg>
                                  <p className="text-muted fs-7 fw-400 mb-0">
                                    10 {t("shares")}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center flex-wrap gap-3 gap-md-4">
                                <button
                                  type="button"
                                  className="btn-primary d-flex align-items-center gap-3 border border-primary rounded-2 mt-4 fw-400 fs-7"
                                >
                                  {t("invite")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_626_2828"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_626_2828)">
                                      <path
                                        d="M7.33203 8.66634H3.33203V7.33301H7.33203V3.33301H8.66536V7.33301H12.6654V8.66634H8.66536V12.6663H7.33203V8.66634Z"
                                        fill="white"
                                      />
                                    </g>
                                  </svg>
                                </button>
                                <button
                                  type="button"
                                  className="btn-secondary bg-transparent text-primary border-primary border fw-400 fs-7 d-flex align-items-center gap-3 rounded-2 mt-4"
                                >
                                 {t("manage")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_626_2834"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_626_2834)">
                                      <path
                                        d="M8.0013 15.333L3.2013 11.733C3.03464 11.6108 2.90408 11.4552 2.80964 11.2663C2.71519 11.0775 2.66797 10.8775 2.66797 10.6663V2.66634C2.66797 2.29967 2.79852 1.98579 3.05964 1.72467C3.32075 1.46356 3.63464 1.33301 4.0013 1.33301H12.0013C12.368 1.33301 12.6819 1.46356 12.943 1.72467C13.2041 1.98579 13.3346 2.29967 13.3346 2.66634V10.6663C13.3346 10.8775 13.2874 11.0775 13.193 11.2663C13.0985 11.4552 12.968 11.6108 12.8013 11.733L8.0013 15.333ZM8.0013 13.6663L12.0013 10.6663V2.66634H4.0013V10.6663L8.0013 13.6663ZM7.3013 9.99967L11.068 6.23301L10.1346 5.26634L7.3013 8.09968L5.9013 6.69967L4.93464 7.63301L7.3013 9.99967Z"
                                        fill="#002FA7"
                                      />
                                    </g>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="card border-0">
                          <div className="card-header bg-transparent border-0 pt-4 px-4 px-lg-4 pb-0">
                            <div className="d-flex justify-content-between align-items-start gap-3">
                              <div>
                                <h4 className="fw-400 text-black">
                                {t("summerbootcamp")}{" "}

                                </h4>
                                <div className="d-flex align-items-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_626_2815"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x={0}
                                      y={0}
                                      width={16}
                                      height={16}
                                    >
                                      <rect
                                        width={16}
                                        height={16}
                                        fill="#D9D9D9"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_626_2815)">
                                      <path
                                        d="M11.332 10.0003C10.8654 10.0003 10.4709 9.83921 10.1487 9.51699C9.82648 9.19477 9.66536 8.80032 9.66536 8.33366C9.66536 7.86699 9.82648 7.47255 10.1487 7.15033C10.4709 6.8281 10.8654 6.66699 11.332 6.66699C11.7987 6.66699 12.1931 6.8281 12.5154 7.15033C12.8376 7.47255 12.9987 7.86699 12.9987 8.33366C12.9987 8.80032 12.8376 9.19477 12.5154 9.51699C12.1931 9.83921 11.7987 10.0003 11.332 10.0003ZM7.9987 13.3337V12.4003C7.9987 12.1337 8.06814 11.8864 8.20703 11.6587C8.34592 11.4309 8.54314 11.267 8.7987 11.167C9.1987 11.0003 9.61259 10.8753 10.0404 10.792C10.4681 10.7087 10.8987 10.667 11.332 10.667C11.7654 10.667 12.1959 10.7087 12.6237 10.792C13.0515 10.8753 13.4654 11.0003 13.8654 11.167C14.1209 11.267 14.3181 11.4309 14.457 11.6587C14.5959 11.8864 14.6654 12.1337 14.6654 12.4003V13.3337H7.9987ZM6.66536 8.00033C5.93203 8.00033 5.30425 7.73921 4.78203 7.21699C4.25981 6.69477 3.9987 6.06699 3.9987 5.33366C3.9987 4.60033 4.25981 3.97255 4.78203 3.45033C5.30425 2.9281 5.93203 2.66699 6.66536 2.66699C7.3987 2.66699 8.02647 2.9281 8.5487 3.45033C9.07092 3.97255 9.33203 4.60033 9.33203 5.33366C9.33203 6.06699 9.07092 6.69477 8.5487 7.21699C8.02647 7.73921 7.3987 8.00033 6.66536 8.00033ZM1.33203 13.3337V11.467C1.33203 11.0892 1.42648 10.742 1.61536 10.4253C1.80425 10.1087 2.06536 9.86699 2.3987 9.70033C3.06536 9.36699 3.75703 9.11144 4.4737 8.93366C5.19036 8.75588 5.92092 8.66699 6.66536 8.66699C7.05425 8.66699 7.44314 8.70033 7.83203 8.76699C8.22092 8.83366 8.60981 8.91144 8.9987 9.00033L7.86536 10.1337C7.66536 10.0781 7.46536 10.042 7.26536 10.0253C7.06536 10.0087 6.86536 10.0003 6.66536 10.0003C6.02092 10.0003 5.39036 10.0781 4.7737 10.2337C4.15703 10.3892 3.56536 10.6114 2.9987 10.9003C2.88759 10.9559 2.80425 11.0337 2.7487 11.1337C2.69314 11.2337 2.66536 11.3448 2.66536 11.467V12.0003H6.66536V13.3337H1.33203ZM6.66536 6.66699C7.03203 6.66699 7.34592 6.53644 7.60703 6.27533C7.86814 6.01421 7.9987 5.70033 7.9987 5.33366C7.9987 4.96699 7.86814 4.6531 7.60703 4.39199C7.34592 4.13088 7.03203 4.00033 6.66536 4.00033C6.2987 4.00033 5.98481 4.13088 5.7237 4.39199C5.46259 4.6531 5.33203 4.96699 5.33203 5.33366C5.33203 5.70033 5.46259 6.01421 5.7237 6.27533C5.98481 6.53644 6.2987 6.66699 6.66536 6.66699Z"
                                        fill="#000C2A"
                                      />
                                    </g>
                                  </svg>
                                  <p className="text-muted fs-7 fw-400 mb-0">
                                  200 {t("members")}{" "}

                                  </p>
                                </div>
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <mask
                                  id="mask0_627_3079"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x={0}
                                  y={0}
                                  width={24}
                                  height={24}
                                >
                                  <rect width={24} height={24} fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_627_3079)">
                                  <path
                                    d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z"
                                    fill="#1C1B1F"
                                  />
                                </g>
                              </svg>
                            </div>
                          </div>
                          <div className="card-body p-4 p-lg-4">
                            <div className="learning-groups-images-main ms-3">
                              <img
                                src="admin-images/png/learning-groups-avatar-1.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-2.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-3.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-4.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-5.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-6.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-7.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-8.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-9.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-10.png"
                                alt=""
                              />
                              <img
                                src="admin-images/png/learning-groups-avatar-11.png"
                                alt=""
                              />
                            </div>
                            <p className="text-muted fs-7 fw-400 mb-0 mt-4">
                            {t("joindes")}

                            </p>
                            <div className="d-flex flex-wrap h-100 gap-3 mt-4">
                              <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                              {t("marketingandsales")}

                              </span>
                              <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                              {t("technicalandsecurity")}

                              </span>
                              <span className="badge badge-light rounded-2 fw-400 fs-7 px-2">
                               {t("education")}
                              </span>
                            </div>
                            <p className="text-black fs-7 fw-400 mt-4">
                            {t("recentactivity")}{" "}

                            </p>
                            <div className="row justify-content-between align-items-center g-3">
                              <div className="col-7 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_627_3105"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_627_3105)">
                                    <path
                                      d="M3.33203 14.0003V2.66699H9.33203L9.5987 4.00033H13.332V10.667H8.66536L8.3987 9.33366H4.66536V14.0003H3.33203ZM9.76537 9.33366H11.9987V5.33366H8.4987L8.23203 4.00033H4.66536V8.00033H9.4987L9.76537 9.33366Z"
                                      fill="#000C2A"
                                    />
                                  </g>
                                </svg>
                                <p className="text-muted fs-7 fw-400 mb-0">
                                  5 {t("newupdates")}
                                </p>
                              </div>
                              <div className="col-5 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_627_3114"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_627_3114)">
                                    <path
                                      d="M11.9987 14.0003H4.66536V5.33366L9.33203 0.666992L10.1654 1.50033C10.2431 1.5781 10.307 1.68366 10.357 1.81699C10.407 1.95033 10.432 2.0781 10.432 2.20033V2.43366L9.6987 5.33366H13.9987C14.3543 5.33366 14.6654 5.46699 14.932 5.73366C15.1987 6.00033 15.332 6.31144 15.332 6.66699V8.00033C15.332 8.0781 15.3209 8.16144 15.2987 8.25033C15.2765 8.33921 15.2543 8.42255 15.232 8.50033L13.232 13.2003C13.132 13.4225 12.9654 13.6114 12.732 13.767C12.4987 13.9225 12.2543 14.0003 11.9987 14.0003ZM5.9987 12.667H11.9987L13.9987 8.00033V6.66699H7.9987L8.8987 3.00033L5.9987 5.90033V12.667ZM4.66536 5.33366V6.66699H2.66536V12.667H4.66536V14.0003H1.33203V5.33366H4.66536Z"
                                      fill="#000C2A"
                                    />
                                  </g>
                                </svg>
                                <p className="text-muted fs-7 fw-400 mb-0">
                                  134 {t("likes")}
                                </p>
                              </div>
                              <div className="col-7 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_627_3122"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_627_3122)">
                                    <path
                                      d="M1.33203 14.6667V2.66667C1.33203 2.3 1.46259 1.98611 1.7237 1.725C1.98481 1.46389 2.2987 1.33333 2.66536 1.33333H9.3987C9.35425 1.55556 9.33203 1.77778 9.33203 2C9.33203 2.22222 9.35425 2.44444 9.3987 2.66667H2.66536V11.4167L3.43203 10.6667H13.332V5.26667C13.5876 5.21111 13.8265 5.13611 14.0487 5.04167C14.2709 4.94722 14.4765 4.82222 14.6654 4.66667V10.6667C14.6654 11.0333 14.5348 11.3472 14.2737 11.6083C14.0126 11.8694 13.6987 12 13.332 12H3.9987L1.33203 14.6667ZM12.6654 4C12.1098 4 11.6376 3.80556 11.2487 3.41667C10.8598 3.02778 10.6654 2.55556 10.6654 2C10.6654 1.44444 10.8598 0.972222 11.2487 0.583333C11.6376 0.194444 12.1098 0 12.6654 0C13.2209 0 13.6931 0.194444 14.082 0.583333C14.4709 0.972222 14.6654 1.44444 14.6654 2C14.6654 2.55556 14.4709 3.02778 14.082 3.41667C13.6931 3.80556 13.2209 4 12.6654 4Z"
                                      fill="#000C2A"
                                    />
                                  </g>
                                </svg>
                                <p className="text-muted fs-7 fw-400 mb-0">
                                  29 {t("comments")}
                                </p>
                              </div>
                              <div className="col-5 col-md-6 col-lg-4 d-flex align-items-center gap-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_627_3130"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_627_3130)">
                                    <path
                                      d="M12 14.6663C11.4444 14.6663 10.9722 14.4719 10.5833 14.083C10.1944 13.6941 10 13.2219 10 12.6663C10 12.5886 10.0056 12.508 10.0167 12.4247C10.0278 12.3413 10.0444 12.2663 10.0667 12.1997L5.36667 9.46634C5.17778 9.63301 4.96667 9.76356 4.73333 9.85801C4.5 9.95245 4.25556 9.99967 4 9.99967C3.44444 9.99967 2.97222 9.80523 2.58333 9.41634C2.19444 9.02745 2 8.55523 2 7.99967C2 7.44412 2.19444 6.9719 2.58333 6.58301C2.97222 6.19412 3.44444 5.99967 4 5.99967C4.25556 5.99967 4.5 6.0469 4.73333 6.14134C4.96667 6.23579 5.17778 6.36634 5.36667 6.53301L10.0667 3.79967C10.0444 3.73301 10.0278 3.65801 10.0167 3.57467C10.0056 3.49134 10 3.41079 10 3.33301C10 2.77745 10.1944 2.30523 10.5833 1.91634C10.9722 1.52745 11.4444 1.33301 12 1.33301C12.5556 1.33301 13.0278 1.52745 13.4167 1.91634C13.8056 2.30523 14 2.77745 14 3.33301C14 3.88856 13.8056 4.36079 13.4167 4.74967C13.0278 5.13856 12.5556 5.33301 12 5.33301C11.7444 5.33301 11.5 5.28579 11.2667 5.19134C11.0333 5.0969 10.8222 4.96634 10.6333 4.79967L5.93333 7.53301C5.95556 7.59967 5.97222 7.67467 5.98333 7.75801C5.99444 7.84134 6 7.9219 6 7.99967C6 8.07745 5.99444 8.15801 5.98333 8.24134C5.97222 8.32467 5.95556 8.39967 5.93333 8.46634L10.6333 11.1997C10.8222 11.033 11.0333 10.9025 11.2667 10.808C11.5 10.7136 11.7444 10.6663 12 10.6663C12.5556 10.6663 13.0278 10.8608 13.4167 11.2497C13.8056 11.6386 14 12.1108 14 12.6663C14 13.2219 13.8056 13.6941 13.4167 14.083C13.0278 14.4719 12.5556 14.6663 12 14.6663ZM12 3.99967C12.1889 3.99967 12.3472 3.93579 12.475 3.80801C12.6028 3.68023 12.6667 3.5219 12.6667 3.33301C12.6667 3.14412 12.6028 2.98579 12.475 2.85801C12.3472 2.73023 12.1889 2.66634 12 2.66634C11.8111 2.66634 11.6528 2.73023 11.525 2.85801C11.3972 2.98579 11.3333 3.14412 11.3333 3.33301C11.3333 3.5219 11.3972 3.68023 11.525 3.80801C11.6528 3.93579 11.8111 3.99967 12 3.99967ZM4 8.66634C4.18889 8.66634 4.34722 8.60245 4.475 8.47467C4.60278 8.3469 4.66667 8.18856 4.66667 7.99967C4.66667 7.81079 4.60278 7.65245 4.475 7.52467C4.34722 7.3969 4.18889 7.33301 4 7.33301C3.81111 7.33301 3.65278 7.3969 3.525 7.52467C3.39722 7.65245 3.33333 7.81079 3.33333 7.99967C3.33333 8.18856 3.39722 8.3469 3.525 8.47467C3.65278 8.60245 3.81111 8.66634 4 8.66634ZM12 13.333C12.1889 13.333 12.3472 13.2691 12.475 13.1413C12.6028 13.0136 12.6667 12.8552 12.6667 12.6663C12.6667 12.4775 12.6028 12.3191 12.475 12.1913C12.3472 12.0636 12.1889 11.9997 12 11.9997C11.8111 11.9997 11.6528 12.0636 11.525 12.1913C11.3972 12.3191 11.3333 12.4775 11.3333 12.6663C11.3333 12.8552 11.3972 13.0136 11.525 13.1413C11.6528 13.2691 11.8111 13.333 12 13.333Z"
                                      fill="#000C2A"
                                    />
                                  </g>
                                </svg>
                                <p className="text-muted fs-7 fw-400 mb-0">
                                  10 {t("shares")}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center flex-wrap gap-3 gap-md-4">
                              <button
                                type="button"
                                className="btn-primary d-flex align-items-center gap-3 border border-primary rounded-2 mt-4 fw-400 fs-7"
                              >
                               {t("invite")}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_626_2828"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_626_2828)">
                                    <path
                                      d="M7.33203 8.66634H3.33203V7.33301H7.33203V3.33301H8.66536V7.33301H12.6654V8.66634H8.66536V12.6663H7.33203V8.66634Z"
                                      fill="white"
                                    />
                                  </g>
                                </svg>
                              </button>
                              <button
                                type="button"
                                className="btn-secondary bg-transparent text-primary border-primary border fw-400 fs-7 d-flex align-items-center gap-3 rounded-2 mt-4"
                              >
                               {t("manage")}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_626_2834"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x={0}
                                    y={0}
                                    width={16}
                                    height={16}
                                  >
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_626_2834)">
                                    <path
                                      d="M8.0013 15.333L3.2013 11.733C3.03464 11.6108 2.90408 11.4552 2.80964 11.2663C2.71519 11.0775 2.66797 10.8775 2.66797 10.6663V2.66634C2.66797 2.29967 2.79852 1.98579 3.05964 1.72467C3.32075 1.46356 3.63464 1.33301 4.0013 1.33301H12.0013C12.368 1.33301 12.6819 1.46356 12.943 1.72467C13.2041 1.98579 13.3346 2.29967 13.3346 2.66634V10.6663C13.3346 10.8775 13.2874 11.0775 13.193 11.2663C13.0985 11.4552 12.968 11.6108 12.8013 11.733L8.0013 15.333ZM8.0013 13.6663L12.0013 10.6663V2.66634H4.0013V10.6663L8.0013 13.6663ZM7.3013 9.99967L11.068 6.23301L10.1346 5.26634L7.3013 8.09968L5.9013 6.69967L4.93464 7.63301L7.3013 9.99967Z"
                                      fill="#002FA7"
                                    />
                                  </g>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default BusinessLearningGroups;
